import Vue from 'vue/dist/vue.esm'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'
//modules
import round1 from './modules/round1'
import round2 from './modules/round2'
import expenses from './modules/expenses'
import documents from './modules/documents'
import signseal from './modules/signseal'
import travelers from './modules/travelers'

Vue.use(Vuex)

let store = new Vuex.Store({
  strict: !['production', 'staging'].includes(process.env.NODE_ENV),
  state,
  getters,
  mutations,
  actions,
  modules: {
    round1: round1,
    round2: round2,
    expenses: expenses,
    documents: documents,
    signseal: signseal,
    travelers: travelers
  },
  plugins: [createPersistedState({
    reducer: (state) => ({
      round1: state.round1
    })
  })]
})
export default store